export const Hamburger = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15.1429" cy="8.14286" r="2.14286" fill="#858DBD" />
      <circle cx="15.1429" cy="15" r="2.14286" fill="#858DBD" />
      <circle cx="15.1429" cy="21.8572" r="2.14286" fill="#858DBD" />
    </svg>
  );
};
